export default "__VITE_ASSET__DCXPhKHK__"